import useSWR from "swr"
import { PullSheetApi } from "../../../apis"

export interface IPullSheetOption {
  id: string
  refCode: string
  pullSheetStatus: string
  loadingDate?: string | null
  dispatchedDate?: string | null
  warehouse?: { refCode?: string; name?: string } | null
  staff?: { firstName?: string; lastName?: string } | null
}

export function useActivePullSheetsQuery() {
  return useSWR(
    ["pull-sheets-for-shortage"],
    async () => {
      const res = await PullSheetApi.list({
        filter: {} as any,
        offset: { page: "1", limit: "100" } as any,
        order: ["createdAt", "DESC"] as any,
      } as any)
      return (res?.rows ?? []) as IPullSheetOption[]
    },
    { revalidateOnFocus: false },
  )
}
